import axiosInstance from "../../axios/instance";
import { normalizeToUTC } from "@revbox/helpers-fe";
import { endOfDay, startOfDay } from "date-fns";
import { getToken } from "../../helpers/get-token";

async function getPeriodAvgCTR(currentPeriod, previousPeriod) {
    try {
        const token = getToken();
        axiosInstance.defaults.headers.common['authorization'] = token;


        const response = await axiosInstance.post(process.env.REACT_APP_HUB_URL + '/api/analytics/revenue/period/avg-ctr', {
            // add one day
            current_period: [startOfDay(normalizeToUTC(currentPeriod[0])).getTime(), endOfDay(normalizeToUTC(new Date(currentPeriod[1])).getTime() + 86400000).getTime()],
            previous_period: [startOfDay(normalizeToUTC(previousPeriod[0])).getTime(), endOfDay(normalizeToUTC(new Date(previousPeriod[1])).getTime() + 86400000).getTime()]
        })

        return response?.data;
    } catch (error) {
        console.log(error);
    }
}

export default getPeriodAvgCTR;
